var path = 'public/app/plugins/panel/unknown/module.html';
var html = "<div class=text-center style=padding-top:2rem>\n\tUnknown panel type: <strong>{{ctrl.panel.type}}</strong>\n</div>\n\n\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./public/app/plugins/panel/unknown/module.html
// module id = 678
// module chunks = 5